import { useEffect, useState } from "react";

/* ── Lightweight imperative toast (replaces browser alert()) ──
   Call toast("Saved") from anywhere. <ToastHost/> is mounted once at the app
   root and renders a stack of auto-dismissing toasts. Type auto-detected from
   the message (error / success / info) when not passed. */

let _id = 0;
let listeners = [];

const detect = (msg) => {
  if (/fail|error|invalid|cannot|could not|not found|denied|required|wrong|❌|⚠/i.test(msg)) return "error";
  if (/success|saved|updated|added|created|done|sent|deleted|removed|approved|✅/i.test(msg)) return "success";
  return "info";
};

export function toast(message, type) {
  const msg = String(message ?? "");
  if (!msg) return;
  const t = { id: ++_id, message: msg, type: type || detect(msg) };
  listeners.forEach((l) => l(t));
}

const BG = { success: "#065f46", error: "#b91c1c", info: "#0f172a" };
const ICON = { success: "✅", error: "⚠️", info: "" };

export function ToastHost() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const on = (t) => {
      setItems((p) => [...p, t]);
      setTimeout(() => setItems((p) => p.filter((x) => x.id !== t.id)), 3200);
    };
    listeners.push(on);
    return () => { listeners = listeners.filter((l) => l !== on); };
  }, []);

  if (!items.length) return null;
  return (
    <div style={{
      position: "fixed", bottom: 24, left: "50%", transform: "translateX(-50%)",
      zIndex: 99999, display: "flex", flexDirection: "column", gap: 8,
      alignItems: "center", pointerEvents: "none",
    }}>
      {items.map((t) => (
        <div key={t.id} style={{
          background: BG[t.type] || BG.info, color: "#fff",
          padding: "10px 18px", borderRadius: 10, fontSize: 13.5, fontWeight: 600,
          boxShadow: "0 10px 30px rgba(0,0,0,.20)", maxWidth: "90vw",
          display: "flex", alignItems: "center", gap: 8,
        }}>
          {ICON[t.type] && <span>{ICON[t.type]}</span>}
          {t.message}
        </div>
      ))}
    </div>
  );
}
